import { useState } from "react";
import "./Management.css";
import Avatar from '../Images/leader_1.png'
import Avatar1 from '../Images/team.png'
import Avatar2 from '../Images/leader_2.png'
import Avatar3 from '../Images/leader_3.png'
import Avatar4 from '../Images/leader_4.png'
import Avatar5 from '../Images/sunny.png'
import Aboutbg from '../Images/leadbg.jpeg'
import { FaLinkedin, FaTimes } from "react-icons/fa";
import Footer from "../Component/NewFooter";

const teamMembers = [
  {
    id: 1,
    name: "Jemide Temile",
    role: "Managing Director",
    img: Avatar,
    linkedin: "#",
    featured: true,
    bio: `Jemide Temile, Managing Director of Jeyshawn Engineering Limited, is a seasoned professional with an extensive background in executing complex EPCIC (Engineering, Procurement, Construction, Installation, and Commissioning) projects within the oil and gas sector. His leadership spans the entire project lifecycle, emphasizing safety, budgetary discipline, and timely delivery.

He is distinguished by his commitment to operational excellence, innovation and safety. Under his guidance, Jeyshawn Engineering Limited has enhanced its technical capabilities and maintained a rigorous culture of quality and continuous improvement. This strategic focus has established the firm as a premier, reliable partner for high-stakes engineering solutions. Jemide, is an alumnus of the University of Port Harcourt, Rivers State, he is also a member of several professional and corporate bodies.`,
  },
  {
    id: 2,
    name: "Harrison Gharoro",
    role: "Finance Manager",
    img: Avatar2,
    linkedin: "#",
    featured: false,
    bio: `Harrison Gharoro is a Fellow of the Institute of Chartered Accountant of Nigeria (ICAN) and the Chartered Institute of Taxation of Nigeria (CITN). He also has a Master’s in Business Administration (MBA) from Rivers State University (formerly Rivers State University of Science and Technology), Port Harcourt, Rivers State and a Bachelor of Science (BSc.) in Accounting from University of Uyo, Akwa Ibom State.

Before joining Jeyshawn Engineering Limited as a Finance Manager, he previously worked with Petrofac Energy Services Nigeria Limited in Lagos and Chevron Oil Nigeria Plc (formerly Texaco Nigeria PLC) as an Oil & Gas Finance Expert.`,
  },
  {
    id: 3,
    name: "Rachelle Udoumoh, FCCA",
    role: "Manager, Corporate Services",
    img: Avatar3,
    linkedin: "#",
    featured: false,
    bio: `Rachelle Etop Udoumoh, FCCA, is a highly strategic Chartered Accountant and Fellow of the Association of Chartered Certified Accountants (ACCA), serving as the Corporate Services Manager at Jeyshawn Engineering Limited, with over 8 years of experience in driving operational excellence and financial accountability. She specializes in integrating rigorous financial management principles into daily corporate functions, including process efficiency and strategic cost management.

​Rachelle’s professional foundation is built on elite certifications, including memberships with the Chartered Institute of Taxation of Nigeria (CITN) and the Financial Modelling and Valuation Analyst (FMVA) program. She has furthered her expertise through Harvard Business School, specializing in financial accounting, Strategic Financial Analysis and Alternative Investment. This combination of technical accounting mastery and leadership allows her to streamline administrative processes and boost cross-functional productivity across the organization.`,
  },
  {
    id: 5,
    name: "Sunny Imo, MNSE, COREN ",
    role: "Operations Manager",
    img: Avatar5,
    linkedin: "#",
    featured: false,
    bio: `Sunny Imo is a highly accomplished Operations Manager with over 19 years of experience in Project Engineering Management, construction management, quality assurance and quality control (QA/QC), and the successful delivery of complex oil and gas infrastructure projects. He is currently the Operations Manager for Jeyshawn Engineering Limited, sunny is a registered member of the Nigerian Society of Engineers (MNSE) and the Council for the Regulation of Engineering in Nigeria (COREN).

    Throughout his career, Sunny has played key roles in the planning, execution, supervision, and commissioning of major onshore and offshore projects for leading industry operators, including: Renaissance, SPDC, Metka, TotalEnergies, and ExxonMobil. His expertise covers Project Management/coordination, construction management, quality systems implementation, engineering compliance, and stakeholder engagement.
    
    He possesses extensive knowledge of international engineering standards, industry regulations and best practices applicable to oil and gas projects. His proficiency in Project Quality Plans (PQP), Quality Management Systems (QMS), construction methodologies and commissioning processes has contributed to the successful delivery of projects that meet stringent quality, safety and performance requirements.


    Recognized for his leadership, technical competence and commitment to excellence, Sunny consistently ensures that projects are delivered safely, on schedule, within budget and in full compliance with client specifications and QHSE standards. His dedication to quality and operational efficiency makes him an asset in the execution of challenging engineering projects.    `,
  },
  {
    id: 4,
    name: "PAUL OBOIGBE",
    role: "QHSE Manager",
    img: Avatar4,
    linkedin: "#",
    featured: false,
    bio: `Paul A. Oboigbe is a result-driven QHSE professional with over 17 years of progressive experience across oil & gas, EPC, and manufacturing industry. He has proven expertise in implementing and auditing integrated management systems (ISO 9001, 14001, 45001), leading QHSE initiatives that reduced TRIR by 40%, and ensuring regulatory compliance across multi-site operations.

He is adept at risk management, behavioral safety, and contractor supervision in multicultural environments.`,
  },
];

// function LinkedInIcon() {
//   return (
//     <svg className="linkedin-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="LinkedIn">
//       <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.13 1.45-2.13 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14zm1.78 13.02H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45C23.2 24 24 23.23 24 22.27V1.73C24 .77 23.2 0 22.22 0z" />
//     </svg>
//   );
// }

function MemberModal({ member, onClose }) {
  if (!member) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>

        <button className="modal__close" onClick={onClose} aria-label="Close">
          <FaTimes />
        </button>

        <div className="modal__left">
          <img src={member.img} alt={member.name} className="modal__img" />
            <a
            href={member.linkedin}
            className="modal__linkedin"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
        </div>

        <div className="modal__right">
          <h2 className="modal__name">{member.name}</h2>
          <p className="modal__role">{member.role}</p>
          <div className="modal__bio">
            {member.bio.split("\n\n").map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

function MemberCard({ member, onClick }) {
  return (
    <div
      className={`member-card${member.featured ? " member-card--featured" : ""}`}
      onClick={() => onClick(member)}
      style={{ cursor: "pointer" }}
    >
      <div className="member-card__img-wrap">
        <img src={member.img} alt={member.name} className="member-card__img" />
      </div>
      <div className="member-card__body">
        <h3 className="member-card__name">{member.name}</h3>
        <p className="member-card__role">{member.role}</p>
        {/* <a
          href={member.linkedin}
          className="member-card__linkedin"
          aria-label="LinkedIn Profile"
          onClick={(e) => e.stopPropagation()}
        >
          <LinkedInIcon />
        </a> */}
      </div>
    </div>
  );
}

export default function ManagementTeam() {
  const [selected, setSelected] = useState(null);

  const featured = teamMembers.filter((m) => m.featured);
  const rest = teamMembers.filter((m) => !m.featured);

  return (
    <>
    
      <div className="img_carriersmg">
        <img src={Avatar1} alt="" />
      </div>
   
    <section className="management-team " style={{backgroundImage: `url(${Aboutbg})`,}}>
      <div className="management-team__header">
        <h2 className="management-team__title">Management Team</h2>
        <span className="management-team__divider" />
      </div>

      <div className="management-team__featured-row">
        {featured.map((m) => (
          <MemberCard key={m.id} member={m} onClick={setSelected} />
        ))}
      </div>

      <div className="management-team__grid">
        {rest.map((m) => (
          <MemberCard key={m.id} member={m} onClick={setSelected} />
        ))}
      </div>

      <MemberModal member={selected} onClose={() => setSelected(null)} />

    </section>
        <Footer />
     </>
  );
}